"use client";

import {useEffect, Suspense} from "react";
import {usePathname, useSearchParams} from "next/navigation";
import {progress} from "@/lib/progress";

progress.configure({
    showSpinner: false,
    minimum: 0.3,
    easing: "ease",
    speed: 500,
    trickle: true,
    trickleSpeed: 200,
});

function TopLoaderComponent() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        // Start progress on route change
        progress.start();

        // Use requestIdleCallback to wait for page to be fully interactive
        // Fallback to setTimeout if requestIdleCallback is not available
        let timeoutId: NodeJS.Timeout | undefined;
        let idleId: number | undefined;

        const completeProgress = () => {
            progress.done();
        };

        if (typeof window !== "undefined" && "requestIdleCallback" in window) {
            idleId = window.requestIdleCallback(completeProgress, {timeout: 1000});
        } else {
            timeoutId = setTimeout(completeProgress, 800);
        }

        return () => {
            if (idleId !== undefined) {
                window.cancelIdleCallback(idleId);
            }
            if (timeoutId !== undefined) {
                clearTimeout(timeoutId);
            }
            progress.done();
        };
    }, [pathname, searchParams]);

    return null;
}

export function TopLoader() {
    return (
        <Suspense fallback={null}>
            <TopLoaderComponent />
        </Suspense>
    );
}
